import { ApolloProvider } from "@apollo/client";
import React from "react";
import ReactDOM from "react-dom/client";
import "./global.css";
import { ThemeProvider } from "styled-components";
import App from "./App";
import client from "./lib/apollo";
import AdminUserProvider from "./modules/common/providers/AdminUserProvider";
import reportWebVitals from "./reportWebVitals";
import { theme, GlobalStyle } from "./utilities/theme";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <ApolloProvider client={client}>
        <AdminUserProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AdminUserProvider>
      </ApolloProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
